import React from 'react'
import { Button, Row, Col } from "antd";
import { ArrowLeftOutlined, FrownOutlined } from '@ant-design/icons';
import { APP_NAME } from 'configs/AppConfig';
import { Link } from 'react-router-dom';
import Flex from 'components/shared-components/Flex';
import { useSelector } from 'react-redux';

const ErrorOne = () => {
	const theme = useSelector(state => state.theme.currentTheme)
	return (
		<div className={`h-100 ${theme === 'light' ? 'bg-white' : ''}`}>
			<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
				{/* <div>
					<img className="img-fluid" src={`/img/${theme === 'light' ? 'logo.png': 'logo-white.png'}`} alt="" />
				</div> */}
				<div className="container">
					<Row align="middle">
						<Col xs={24} sm={24} md={8}>
							<h1 className="font-weight-bold mb-4 display-4">
								Access Denied</h1>
							<p className="font-size-md mb-4">
								Access restricted. You are not authorized to view this page.
								If you need access, please reach out to your administrator.
							</p>
							<Link to='/app/dashboard'>
								<Button type="primary" icon={<ArrowLeftOutlined />} style={{
									borderRadius: 10,
									background: "linear-gradient(90deg, #D100FF, #8B00C8)",
									border: "none",
									color: "#fff",
									transition: "background 0.3s ease-in-out",
								}}>Go back</Button>
							</Link>
						</Col>
						<Col xs={24} sm={24} md={{ span: 14, offset: 2 }}>
							<img className="img-fluid mt-md-0 mt-4" src="/img/others/img-23.png" alt="" />
						</Col>
					</Row>
				</div>
			</div>
		</div>
	)
}

export default ErrorOne
